//--------不放在对象里面是为了私有化，不让外面的拿到---这样做也有弊端，导致整个系统都只能用同一个allListener-------
let allListener = [];
const findListener = (listenerName) => {
    return allListener.find(listener => listener.name === listenerName);
};
class LastPlaybackRecorder{

    list = [];
    map = {};
    add(listenerName, params){
        if(!this.exists(listenerName)){
            this.list.push(listenerName);
        }
        this.map[listenerName] = params;
    }

    exists(listenerName){
        return this.list.indexOf(listenerName) !== -1;
    }

    getParams(listenerName){
        return this.map[listenerName];
    }

    remove(listenerName){
        this.list = this.list.filter(name => listenerName !== name);
        delete this.map[listenerName];
    }

}
let lastPlaybackRecorder = new LastPlaybackRecorder();//记录最后一次的回放记录器
class BaseEvent{

    playbackRecorder;
    constructor(playbackRecorder) {
        this.playbackRecorder = playbackRecorder;
    }

    destroyBaseEvent(listenerName, listenerFun){
        if(!listenerName || !listenerFun){
            console.error("监听器注册错误！listenerName 或者 listenerFun 必须存在！");
            return;
        }
        if(typeof  listenerFun !== "function"){
            console.error("监听器注册错误！listenerFun 必须是一个方法！");
            return;
        }
        let listener = findListener(listenerName);
        if(listener && listener.stack){
            listener.stack = listener.stack.filter(item => item!==listenerFun);
        }
    }

    registerBaseEvent(listenerName, listenerFun){
        if(!listenerName || !listenerFun){
            console.error("监听器注册错误！listenerName 或者 listenerFun 必须存在！");
            return;
        }
        if(typeof  listenerFun !== "function"){
            console.error("监听器注册错误！listenerFun 必须是一个方法！");
            return;
        }
        let listener = findListener(listenerName);
        if(listener){
            if(!listener.stack){
                listener.stack = []
            }
            listener.stack.push(listenerFun);
        }else{
            listener = {
                name : listenerName,
                stack : [listenerFun]
            };
            allListener.push(listener);
        }

        if(this.playbackRecorder.exists(listenerName)){
            //重放之前的执行结果
            let params = this.playbackRecorder.getParams(listenerName);
            listenerFun(params);
        }
    }

    syncPlaybackExec(listenerName, params){//同步执行, 回放执行，会让后续注册的监听器能够监听到之前执行的结果
        this.playbackRecorder.add(listenerName, params);
        this.syncExec(listenerName, params);
    }

    asyncPlaybackExec(listenerName, params){//异步执行, 回放执行，会让后续注册的监听器能够监听到之前执行的结果
        this.playbackRecorder.add(listenerName, params);
        this.asyncExec(listenerName, params);
    }

    syncExec(listenerName, params){//同步执行
        let listener = findListener(listenerName);
        listener && listener.stack && listener.stack.map(item =>{
            try {
                item && item(params);
            }catch (e) {
                console.error("通知发生异常！ ", listenerName,  params, e );
            }
        })
    }

    asyncExec(listenerName, params){//异步执行
        let listener = findListener(listenerName);
        setTimeout(()=>{
            listener && listener.stack && listener.stack.map(item =>{
                try {
                    item && item(params);
                }catch (e) {
                    console.error("通知发生异常！ ", listenerName,  params, e );
                }
            })
        });
    }

}

export let systemBaseEvent = new BaseEvent(lastPlaybackRecorder);
window.systemBaseEvent = systemBaseEvent;
